import { FC } from 'react';

import encumbrancesExcelModalSteps from '../constants/encumbrancesExcelModalSteps';
import { useEncumbrancesExcelModal } from '../context/EncumbrancesExcelModalContext';
import EncumbrancesExcelImportProgress from './EncumbrancesExcelImportProgress';
import EncumbrancesExcelPreview from './EncumbrancesExcelPreview';
import EncumbrancesExcelUploadView from './EncumbrancesExcelUploadView';

const EncumbrancesExcelModalBody: FC = () => {
  const { data } = useEncumbrancesExcelModal();

  if (data.step === encumbrancesExcelModalSteps.IMPORTING) {
    return <EncumbrancesExcelImportProgress {...data.importProgress} />;
  }

  if (data.step === encumbrancesExcelModalSteps.PREVIEW) {
    return <EncumbrancesExcelPreview />;
  }

  return <EncumbrancesExcelUploadView />;
};

export default EncumbrancesExcelModalBody;
